import { priceChartTargetBars } from '@morfi/chart-policy';
import type { ChartInterval } from '@/lib/chart/types';

export function candleChartTargetBars(plotWidth: number, interval: ChartInterval): number {
  const targetBars = priceChartTargetBars(plotWidth, 'candle');
  // The 64-bar tier gives a full hour one-minute candles. Keep the unmeasured
  // hydration target and narrower viewport tiers; the API still owns resolution.
  return interval === '1h' && Number.isFinite(plotWidth) && plotWidth > 0
    ? Math.min(targetBars, 64)
    : targetBars;
}
